module.exports = "<p>\r\n  callback works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/callback/callback.component.html
// module id = ./src/app/callback/callback.component.html
// module chunks = main